import { CookiesConsentType } from 'types/CookiesConsentType';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const updateConsentMode = (consent: CookiesConsentType) => {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_user_data:
        consent.marketing && consent.analytics ? 'granted' : 'denied',
      ad_personalization: consent.marketing ? 'granted' : 'denied',
      functionality_storage: consent.functional ? 'granted' : 'denied',
      personalization_storage: consent.social ? 'granted' : 'denied',
      security_storage: 'granted',
    });
  }
};

export const triggerConsentEvent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'brij-cookies-initiation',
  });
};
